// ======================================================================
// FILE: src/modules/finance/dashboard/pages/FinanceDashboardPage.js
// MODULE: Finance & Accounts Management System
// COMPONENT: Finance Dashboard
//
// PURPOSE:
//   Landing page for the Finance module.
//
// FEATURES:
//   - Finance page header
//   - Placeholder dashboard
//   - Ready for KPI cards
//   - Ready for charts and widgets
//
// NOTES:
//   - No API calls
//   - No business logic
//   - This page will later display Finance KPIs,
//     Recent Journals, Financial Health, Alerts,
//     Pending Approvals, and Quick Actions.
//
// AUTHOR: DizyPro ERP
// ======================================================================

import React from "react";

// ======================================================================
// COMPONENT
// ======================================================================

export default function FinanceDashboardPage() {

  return (

    <div>

      {/* ========================================================== */}
      {/* PAGE HEADER */}
      {/* ========================================================== */}

      <div
        className="d-flex justify-content-between align-items-center mb-4"
      >

        <div>

          <h2
            className="fw-bold mb-1"
          >
            Finance Dashboard
          </h2>

          <p
            className="text-muted mb-0"
          >
            Manage Finance & Accounts operations.
          </p>

        </div>

      </div>

      {/* ========================================================== */}
      {/* PLACEHOLDER */}
      {/* ========================================================== */}

      <div
        className="card border-0 shadow-sm"
      >

        <div
          className="card-body text-center py-5"
        >

          <i
            className="fas fa-chart-line fa-4x text-primary mb-4"
          />

          <h4
            className="fw-bold"
          >
            Finance Dashboard
          </h4>

          <p
            className="text-muted mb-0"
          >
            Dashboard widgets will be available in the next phase.
          </p>

        </div>

      </div>

    </div>

  );

}